import { NgModule }       from '@angular/core';
import { SourcesService } from './sources.service';

@NgModule({
  providers: [SourcesService]
})
export class SourceModule { }
